import React from "react";
import { Card } from "@/components/ui/card";
import { CheckCircle2, AlertTriangle, XCircle, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

const STATES = {
    OK: {
        label: "OK",
        Icon: CheckCircle2,
        wrapper:
            "bg-ok-bg border-ok/30 text-ok",
        dot: "bg-ok",
        testid: "audit-status-ok",
    },
    DEGRADED: {
        label: "DEGRADED",
        Icon: AlertTriangle,
        wrapper:
            "bg-warn-bg border-warn/30 text-warn",
        dot: "bg-warn",
        testid: "audit-status-degraded",
    },
    FAILED: {
        label: "FAILED",
        Icon: XCircle,
        wrapper:
            "bg-fail/10 border-fail/40 text-fail",
        dot: "bg-fail",
        testid: "audit-status-failed",
    },
    UNKNOWN: {
        label: "SIN DATOS",
        Icon: Circle,
        wrapper:
            "bg-muted border-muted-foreground/30 text-muted-foreground",
        dot: "bg-muted-foreground",
        testid: "audit-status-unknown",
    },
};

export const TrafficLight = ({ status, subtitle, big = true }) => {
    const s = STATES[status?.toUpperCase()] || STATES.UNKNOWN;
    const Icon = s.Icon;
    return (
        <Card
            data-testid={s.testid}
            className={cn(
                "p-5 flex items-center gap-4 border",
                s.wrapper
            )}
        >
            <div className={cn("h-12 w-12 rounded-full flex items-center justify-center", s.dot, "bg-opacity-90")}>
                <Icon className="h-7 w-7 text-white" strokeWidth={2} />
            </div>
            <div>
                <div className={cn("font-mono uppercase tracking-widest", big ? "text-2xl md:text-3xl font-semibold" : "text-xl font-semibold")}>
                    {s.label}
                </div>
                {subtitle && (
                    <div className="text-xs md:text-sm mt-0.5 opacity-80">{subtitle}</div>
                )}
            </div>
        </Card>
    );
};
